import { useMemo } from 'react'

import { useGetUserQuery } from 'common'

import { readBrandRefreshActivationData } from './brandRefreshActivationData'

/**
 * Reads `activation_data.brand_refresh_beta` from the cached user record.
 */
export function useBrandRefreshActivationData(options: { skip?: boolean } = {}) {
  const { data, isLoading } = useGetUserQuery(undefined, { skip: options.skip })
  const blob = useMemo(
    () => readBrandRefreshActivationData(data?.activation_data),
    [data?.activation_data],
  )

  return { blob, isLoading }
}
